/* 劉備傳・第 5 章：三顧草廬（建安十二年，207）
 * 史實：《先主傳》注引《九州春秋》：劉備在劉表席間起身如廁，見髀裏肉生，慨然流涕——「日月若馳，老將至矣，而功業不建」。
 *       《諸葛亮傳》：徐庶薦亮，「先主曰：『君與俱來。』庶曰：『此人可就見，不可屈致也。將軍宜枉駕顧之。』由是先主遂詣亮，凡三往，乃見。」
 *       亮「躬耕隴畝，好爲梁父吟」。見面時劉備自陳「智術淺短，遂用猖蹶，至于今日。然志猶未已」，亮答以隆中對。
 *       之後「關羽、張飛等不悅，先主解之曰：『孤之有孔明，猶魚之有水也。』」二十年後亮在〈出師表〉回想這三顧。
 *       （節令、留書、晝寢、張飛要燒草廬是演義；這一章拿來當玩法，簡報裡註明。）
 * 流程：不打仗。
 *   0. 新野：髀肉之嘆；徐庶薦亮。可以照劉備的第一個念頭「君與俱來」派人去請（使者空手回來），或直接親自去。
 *   1. 一顧（秋）：田間有人唱〈梁父吟〉；童子說先生出門了。二顧（冬）：風雪裡走得慢、關張越來越不悅；諸葛均說兄長不在，門前留書。
 *      每一趟走過的路都留下足跡，下一趟看得到。
 *   2. 三顧（春）：草廬裡傳出歌聲——他在家。童子說又睡下了：站在門外不動等候，天色從午後到黃昏。
 *      張飛等到一半會往屋後去要放火：用 W 護駕把他拉回來（等候只小小中斷），或走過去拉（離開門口，等候倒退），或由他去（放了火，等候也倒退）。
 *   3. 隆中對：諸葛亮在門前空地畫出天下形勢；他每講一段，劉備就把旗插到對的地方（北方不可爭、江東可援、荊益可取）。
 *   4. 同回新野：走到半路，關張不悅，劉備說「猶魚之有水也」；〈出師表〉收尾。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally } from '../kit.ts';
import { XINYE, HUT, DOOR } from '../maps/longzhong.ts';

const LV = 10, WAIT = 30, ZF_AT = [12], HALFWAY = 4200, MSGR = [900, 2120], SINGER = [5600, 2860];
const MAPC = [6600, 2560], PADS = { north: [6600, 2430, '北方'], east: [6860, 2600, '江東'], jing: [6590, 2620, '荊州'], yi: [6330, 2640, '益州'] };
const SONG = ['步出齊城門，遙望蕩陰里。', '里中有三墳，累累正相似。', '問是誰家墓？田疆古冶子。', '力能排南山，文能絕地紀。', '一朝被讒言，二桃殺三士。', '誰能爲此謀？國相齊晏子。'];
const VISITS = [
  { lines: [['童子', '先生今早出門了，不知道往哪裡去。'], ['劉備', '……那改日再來。']] },
  { lines: [['諸葛均', '家兄與崔州平閒遊去了，何時回來也說不準。'], ['劉備', '請轉告令兄，劉備再來拜訪。']] },
];
const TALK = [['隆中老農', '那位先生常抱膝長吟，自比管仲、樂毅。'], ['崔州平', '孔明說時人都不信他，只有我和徐元直知道他的才能。']];
// 隆中對：每一段講完，劉備把旗插到地圖上
const DUI = [
  { say: [['諸葛亮', '曹操已擁百萬之衆，挾天子而令諸侯，此誠不可與爭鋒。'], ['諸葛亮', '孫權據有江東，已歷三世，國險而民附，賢能爲之用，此可以爲援而不可圖也。']], ask: '把「結好」的旗插在可以為援的地方', ok: 'east', flag: '援' },
  { say: [['諸葛亮', '荊州北據漢、沔，利盡南海，東連吳會，西通巴、蜀，此用武之國，而其主不能守，此殆天所以資將軍。']], ask: '把「取」的旗插在用武之國', ok: 'jing', flag: '取' },
  { say: [['諸葛亮', '益州險塞，沃野千里，天府之土。劉璋闇弱，張魯在北，民殷國富而不知存恤。']], ask: '把「取」的旗插在天府之土', ok: 'yi', flag: '取' },
];
const WRONG = {
  north: ['諸葛亮', '曹操已擁百萬之衆，此誠不可與爭鋒。'],
  east: ['諸葛亮', '孫權據有江東，此可以爲援而不可圖也。'],
  jing: ['諸葛亮', '荊州是用武之地，不是求援之所。'],
  yi: ['諸葛亮', '益州在荊州之後；先有荊州，才圖得了益州。'],
};

export default {
  id: 'liubei-5', map: 'longzhong', hero: 'liubei',
  title: '第 5 章　三顧草廬', year: '建安十二年（207）',
  brief: {
    quote: [{ text: '先帝不以臣卑鄙，猥自枉屈，三顧臣於草廬之中，諮臣以當世之事，由是感激，遂許先帝以驅馳。', src: '諸葛亮〈出師表〉' }],
    text: '劉備依附劉表、屯兵新野，年近半百，功業未建。徐庶推薦隆中的諸葛亮。（正史只說「凡三往，乃見」；節令、留書、晝寢、張飛要燒草廬是演義的情節，這一章拿來當玩法。）',
    goals: ['派人去請，或親自去', '往隆中拜訪諸葛亮（三趟）', '第三趟：在門外靜等，管住不耐煩的張飛', '隆中對：把旗插在天下圖上'],
  },
  words: { ally: '劉備軍', foe: '' },
  fuel() { return false; }, // 張飛放的火只燒一下
  stars: [
    { text: '一開始就決定親自去', ok: (m) => !m.vars.sent },
    { text: '門外等候時沒有離開門口', ok: (m) => !m.vars.broke },
    { text: '張飛沒有放火', ok: (m) => !m.vars.zfFire },
  ],
  steps: [
    { // 0. 新野：髀肉之嘆、徐庶薦亮
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = XINYE[0] + 200; me.y = XINYE[1];
        V.trip = 0; V.asked = 0; V.dis = 0; V.trails = [[], [], []]; V.season = 'autumn';
        V.guan = ally(w, 'guanyu', me.x - 100, me.y + 80, LV); V.zf = ally(w, 'zhangfei', me.x - 100, me.y - 80, LV);
        m.folk(HUT[0], HUT[1], { name: '草廬', still: true, near: 1, draw: hut });
        TALK.forEach(([who, say], i) => m.folk(5300 + i * 200, 2800 - i * 100, { name: who, lines: [[who, say]], onHeard: () => { V.asked++; } }));
        V.singer = m.folk(SINGER[0], SINGER[1], { name: '田間老農', still: true });
        V.msgr = m.folk(MSGR[0], MSGR[1], { name: '使者', still: true });
        m.card('吾常身不離鞍，髀肉皆消。今不復騎，髀裏肉生。日月若馳，老將至矣，而功業不建，是以悲耳。', '《先主傳》注引《九州春秋》');
        m.after(6, () => m.line('徐庶', '諸葛孔明者，臥龍也，將軍豈願見之乎？'));
        m.after(9.5, () => m.line('劉備', '君與俱來。'));
        m.after(12.5, () => m.line('徐庶', '此人可就見，不可屈致也。將軍宜枉駕顧之。'));
        m.after(15, () => {
          m.obj('choose', '派人去請（營前的使者），還是親自往隆中？');
          m.mark('msgr', MSGR[0], MSGR[1], '派人去請', true);
          m.mark('hut', DOOR[0], DOOR[1], '草廬');
        });
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        follow(w, V); step(m, w);
        if (!V.sent && m.get('choose')) m.chanAt(me, 'send', MSGR[0], MSGR[1], 120, 1.2, '派人去請', () => {
          V.sent = true; m.unmark('msgr');
          m.line('劉備', '帶上禮物，去隆中請臥龍先生來新野一見。');
          V.msgr.x = -9999;
          m.after(14, () => {
            const p = SG.MAP.nearestFree(w.player.x + 120, w.player.y); V.msgr.x = p[0]; V.msgr.y = p[1];
            m.line('使者', '那位先生不肯來，只說請將軍見諒。');
            m.after(3, () => m.line('劉備', '……元直說得對，此人不可屈致。備親自去。'));
          });
        });
        return !!m.get('choose') && me.x > XINYE[0] + 1300;
      },
    },
    { // 1. 一顧、二顧：不在
      enter(m) {
        const V = m.vars;
        m.done('choose'); m.unmark('msgr');
        m.obj('visit', '往隆中拜訪諸葛亮（第 1 趟）');
        m.obj('dis', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        follow(w, V); step(m, w); sing(m, w, dt);
        if (V.season === 'snow' && !m.idle(me)) V.dis = Math.min(100, V.dis + dt * 1.1);
        m.get('dis').text = `關羽、張飛的不悅：${Math.round(V.dis)}%`;
        if (V.season === 'snow' && !V.grumble && me.x > 3400) { V.grumble = true; m.line('張飛', '天寒地凍，仗也不打，何必冒雪去見一個村夫！'); m.after(3, () => m.line('劉備', '正要讓孔明知道我的誠意。嫌冷就先回去。')); m.after(6, () => m.line('張飛', '……死都不怕，還怕冷！走就走！')); }
        if (V.trip < 2 && !V.atHut && m.near(me, DOOR[0], DOOR[1], 220)) {
          V.atHut = true;
          const v = VISITS[V.trip];
          v.lines.forEach((L, i) => m.after(i * 3.2, () => m.line(L[0], L[1])));
          m.after(v.lines.length * 3.2 + 1, () => {
            if (V.trip === 0) home(m, w);
            else { V.letter = true; m.line('提示', '在門前站一下，給諸葛亮留一封書信。'); }
          });
        }
        if (V.letter) m.chanAt(me, 'letter', DOOR[0], DOOR[1] + 40, 160, 2, '留書', () => { V.letter = false; m.line('旁白', '劉備在門前留下一封書信，冒雪而回。'); m.after(3, () => home(m, w)); });
        return V.trip >= 2 && m.near(me, DOOR[0], DOOR[1], 900);
      },
    },
    { // 2. 三顧：歌聲、門外靜等
      enter(m, w) {
        const V = m.vars, me = w.player;
        m.done('visit');
        m.line('草廬裡的歌聲', SONG[0]);
        m.after(3.2, () => m.line('草廬裡的歌聲', SONG[1]));
        m.after(6.4, () => m.line('劉備', '是〈梁父吟〉……先生在家！'));
        if (me.skillLv[1] === 0 && w.canLearn(me, 1) === '') w.learn(me, 1);
        V.wait = 0; V.zfN = 0; V.waiting = false;
        V.zfSpot = [HUT[0] + 500, HUT[1] + 600]; V.zfBack = [HUT[0] + 420, HUT[1] - 200]; // 張飛在東南邊等；不耐煩時沿東邊繞到草廬後面
        m.obj('wait', '到草廬門口');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, zf = V.zf;
        follow(w, V); step(m, w);
        const near = m.near(me, DOOR[0], DOOR[1] + 60, 170);
        if (!V.waiting) {
          if (!near) return false;
          V.waiting = true;
          m.line('童子', '先生剛唱完歌，又睡下了。');
          m.after(2.5, () => m.line('劉備', '不要驚動先生，我在門外等。'));
          m.after(5, () => m.line('提示', '在門口站著不動等候。張飛不耐煩時，用 W 護駕把他拉回來；走過去拉的話，等候會倒退。'));
          const p = SG.MAP.nearestFree(V.zfSpot[0], V.zfSpot[1]); zf.x = p[0]; zf.y = p[1]; zf.input = {};
          m.get('wait').text = '';
        }
        if (near && m.idle(me)) V.wait += dt;
        V.dis = Math.min(100, V.dis + dt * 1.2);
        m.get('dis').text = `關羽、張飛的不悅：${Math.round(V.dis)}%`;
        // 離開門口：等候倒退
        if (!near && !V.away) { V.away = true; V.broke = true; V.wait = Math.max(0, V.wait - 10); m.line('童子', '咦，客人走了嗎？'); }
        if (near) V.away = false;
        m.get('wait').text = `在門外等候（${Math.floor((V.wait / WAIT) * 100)}%）`;
        // 張飛：等到一定時候就往屋後去
        if (!V.zfGo && V.zfN < ZF_AT.length && V.wait >= ZF_AT[V.zfN]) { V.zfGo = true; V.zfN++; m.line('張飛', '這村夫好大架子！看我去屋後放一把火，看他起不起來！'); }
        if (V.zfGo) {
          zf.input.moveTo = V.zfBack.slice();
          if (SG.gd(zf.x, zf.y, me.x, me.y) < 200) {
            V.zfGo = false; m.line('劉備', '三弟！不得無禮！'); m.after(2, () => m.line('張飛', '……好吧，聽大哥的。')); zf.input.moveTo = V.zfSpot.slice();
            if (near) V.wait = Math.max(0, V.wait - 3); // 用護駕拉回來：等候只小小中斷
          } else if (SG.gd(zf.x, zf.y, V.zfBack[0], V.zfBack[1]) < 100) {
            V.zfGo = false; V.zfFire = true; V.wait = Math.max(0, V.wait - 10);
            m.fire(V.zfBack[0], V.zfBack[1], { dps: 0, life: 5 });
            m.line('童子', '屋後怎麼冒煙了！'); m.after(2.5, () => m.line('劉備', '三弟！快把火撲了！'));
            zf.input.moveTo = V.zfSpot.slice();
          }
        }
        return V.wait >= WAIT;
      },
    },
    { // 3. 隆中對：把旗插在天下圖上
      enter(m, w) {
        const V = m.vars;
        m.done('wait');
        V.kong = ally(w, 'zhugeliang', DOOR[0] + 120, DOOR[1] + 40, LV); V.kong.hold = [DOOR[0] + 120, DOOR[1] + 40];
        V.zf.input.moveTo = [HUT[0] + 300, HUT[1] + 420];
        m.card('由是先主遂詣亮，凡三往，乃見。', '《諸葛亮傳》');
        m.after(5, () => m.line('劉備', '漢室傾頹，姦臣竊命，主上蒙塵。孤不度德量力，欲信大義於天下，而智術淺短，遂用猖蹶，至于今日。'));
        m.after(10, () => m.line('劉備', '然志猶未已，君謂計將安出？'));
        m.after(13.5, () => { V.map = true; m.line('諸葛亮', '自董卓已來，豪傑並起，跨州連郡者不可勝數。'); m.line('旁白', '諸葛亮在門前的空地上畫出天下形勢。'); });
        m.after(17.5, () => ask(m, 0));
        V.flags = {}; V.q = -1;
        m.obj('dui', '聽隆中對');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (V.q < 0 || V.q >= DUI.length || !V.asking) return V.q >= DUI.length && V.duiDone;
        for (const [k, [x, y]] of Object.entries(PADS)) {
          if (V.flags[k]) continue;
          m.chanAt(me, 'pad-' + k + '-' + V.tries, x, y, 70, 1, '插旗', () => {
            V.tries++;
            const d = DUI[V.q];
            if (k !== d.ok) { m.line(WRONG[k][0], WRONG[k][1]); return; }
            V.flags[k] = d.flag; V.asking = false;
            if (V.q + 1 < DUI.length) { m.after(1.5, () => ask(m, V.q + 1)); return; }
            V.q = DUI.length; m.done('dui');
            m.after(1.5, () => m.line('諸葛亮', '若跨有荊、益，保其巖阻，外結好孫權，內脩政理；天下有變，則霸業可成，漢室可興矣。'));
            m.after(6, () => { V.three = true; m.line('劉備', '善！'); });
            m.after(9, () => m.card('於是與亮情好日密。', '《諸葛亮傳》'));
            m.after(14, () => { V.duiDone = true; });
          });
        }
        return false;
      },
    },
    { // 4. 同回新野：如魚得水
      enter(m, w) {
        const V = m.vars;
        V.kong.hold = null; V.zfFree = true;
        m.obj('home', '與孔明同回新野');
        m.mark('xinye', XINYE[0], XINYE[1], '新野');
        m.after(6, () => m.line('張飛', '大哥對一個二十幾歲的書生這般恭敬，俺看不慣。'));
        m.after(10, () => m.line('關羽', '……'));
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        follow(w, V); allyFollow(w, V.kong, me);
        if (V.end || me.x > HALFWAY) return false; // 走到半路就收尾
        V.end = true; m.done('home'); m.unmark('xinye');
        m.card('關羽、張飛等不悅，先主解之曰：「孤之有孔明，猶魚之有水也。願諸君勿復言。」羽、飛乃止。', '《諸葛亮傳》');
        m.after(5, () => { V.dis = 0; m.get('dis').text = '關羽、張飛的不悅：0%'; });
        m.after(6, () => m.card('先帝不以臣卑鄙，猥自枉屈，三顧臣於草廬之中，諮臣以當世之事，由是感激，遂許先帝以驅馳。', '諸葛亮〈出師表〉（二十年後）'));
        m.after(12, () => m.win());
        return false;
      },
    },
  ],
  always(m, w) { follow(w, m.vars); },
  // 足跡：前幾趟走過的路
  ground(ctx, m, view, inView) {
    const V = m.vars;
    if (!V.trails) return;
    V.trails.forEach((tr, i) => {
      if (i === V.trip && m.i <= 2) return; // 這一趟的不畫，只看得到以前的
      ctx.fillStyle = i === 0 ? 'rgba(70,52,32,.35)' : 'rgba(225,235,245,.45)';
      for (const [x, y, s] of tr) if (inView(x, y, 20)) { ctx.beginPath(); ctx.ellipse(x + s * 7, y + s * 4, 7, 4, 0, 0, Math.PI * 2); ctx.fill(); }
    });
    if (V.map && inView(MAPC[0], MAPC[1], 420)) tianxia(ctx, V, view.WS.time);
  },
  // 天色：秋、雪、春；第三趟等到黃昏
  overlay(ctx, m, view, x0, y0, vw, vh) {
    const V = m.vars, T = view.WS.time;
    if (!V.season) return;
    if (V.season === 'autumn') { ctx.fillStyle = 'rgba(210,140,60,.08)'; ctx.fillRect(x0, y0, vw, vh); }
    if (V.season === 'snow') {
      ctx.fillStyle = 'rgba(225,235,245,.22)'; ctx.fillRect(x0, y0, vw, vh);
      ctx.fillStyle = 'rgba(255,255,255,.85)';
      const z = 1 / view.zoom;
      for (let i = 0; i < 160; i++) {
        const sp = 40 + (i % 5) * 18, x = x0 + ((i * 197.3 + T * (14 + (i % 3) * 6)) % vw), y = y0 + ((i * 89.7 + T * sp) % vh);
        ctx.beginPath(); ctx.arc(x + Math.sin(T + i) * 10, y, (1.6 + (i % 3)) * z, 0, Math.PI * 2); ctx.fill();
      }
    }
    if (V.season === 'spring' && m.i === 2 && V.waiting) {
      const k = Math.min(1, V.wait / WAIT);
      ctx.fillStyle = `rgba(240,130,50,${(0.26 * k).toFixed(3)})`; ctx.fillRect(x0, y0, vw, vh);
      ctx.fillStyle = `rgba(30,20,40,${(0.3 * k).toFixed(3)})`; ctx.fillRect(x0, y0, vw, vh);
    }
  },
};

// 一趟結束：回到新野，換季
function home(m, w) {
  const V = m.vars, me = w.player;
  V.trip++; V.atHut = false;
  if (V.trip === 1) { V.season = 'snow'; m.big('時已入冬……'); for (const u of [me, V.guan, V.zf]) w.addBuff(u, { id: '風雪', t: 9999, ms: -0.25 }); }
  else { V.season = 'spring'; m.big('來年開春……'); for (const u of [me, V.guan, V.zf]) { u.buffs = (u.buffs || []).filter((b) => b.id !== '風雪'); w.recalc(u); } }
  const p = SG.MAP.nearestFree(XINYE[0] + 200, XINYE[1]); me.x = p[0]; me.y = p[1]; me.input = {};
  for (const u of [V.guan, V.zf]) { u.x = p[0] - 100; u.y = p[1] + 80; u.input = {}; }
  m.get('visit').text = `往隆中拜訪諸葛亮（第 ${V.trip + 1} 趟）`;
  if (V.trip === 2) m.after(2, () => m.line('劉備', '路上還看得到前兩趟的腳印……再走一趟吧。'));
}
// 記下這一趟的足跡（每 46 px 一步，左右腳交替）
function step(m, w) {
  const V = m.vars, me = w.player, tr = V.trails && V.trails[V.trip];
  if (!tr) return;
  const l = tr[tr.length - 1];
  if (!l || SG.gd(l[0], l[1], me.x, me.y) > 46) tr.push([me.x, me.y, l ? -l[2] : 1]);
}
// 一顧：田間的〈梁父吟〉
function sing(m, w, dt) {
  const V = m.vars, me = w.player;
  if (V.trip !== 0 || V.songI >= SONG.length + 1) return;
  if (SG.gd(me.x, me.y, SINGER[0], SINGER[1]) > 420) return;
  V.songT = (V.songT || 0) - dt;
  if (V.songT > 0) return;
  V.songT = 3.4; V.songI = V.songI || 0;
  if (V.songI < SONG.length) m.line('田間歌聲', SONG[V.songI]);
  else m.line('田間老農', '這是隆中那位先生常唱的〈梁父吟〉。他今天一早出門去了。');
  V.songI++;
}
// 隆中對：問下一段
function ask(m, q) {
  const V = m.vars, d = DUI[q];
  V.q = q; V.tries = (V.tries || 0) + 1;
  d.say.forEach((L, i) => m.after(i * 4.5, () => m.line(L[0], L[1])));
  m.after(d.say.length * 4.5, () => { V.asking = true; m.get('dui').text = d.ask + '（站到地圖上的地方）'; });
}
// 關羽、張飛跟著劉備（第三趟到隆中對，張飛自己待著）
function follow(w, V) {
  for (const u of [V.guan, V.zf]) {
    if (!u || (u === V.zf && V.zfSpot && !V.zfFree)) continue;
    if (SG.gd(u.x, u.y, w.player.x, w.player.y) > 220) u.input.moveTo = [w.player.x - 100 * (w.player.f || 1), w.player.y + (u === V.zf ? -70 : 70)];
  }
}
function allyFollow(w, u, lead) {
  if (u && SG.gd(u.x, u.y, lead.x, lead.y) > 180) u.input.moveTo = [lead.x + 90 * (lead.f || 1), lead.y + 40];
}
// 地上的天下形勢圖：山川、州名；插上的旗；三分之後各塗一色
function tianxia(ctx, V, T) {
  const [cx, cy] = MAPC, W = 640, H = 340;
  ctx.save();
  ctx.fillStyle = 'rgba(200,180,130,.55)'; ctx.strokeStyle = 'rgba(90,60,30,.7)'; ctx.lineWidth = 4;
  ctx.beginPath(); ctx.rect(cx - W / 2, cy - H / 2, W, H); ctx.fill(); ctx.stroke();
  if (V.three) {
    const tint = (pts, col) => { ctx.fillStyle = col; ctx.beginPath(); pts.forEach(([x, y], i) => (i ? ctx.lineTo(cx + x, cy + y) : ctx.moveTo(cx + x, cy + y))); ctx.closePath(); ctx.fill(); };
    tint([[-320, -170], [320, -170], [320, -60], [120, -40], [-80, -60], [-320, -40]], 'rgba(60,90,160,.35)'); // 曹
    tint([[120, -40], [320, -60], [320, 170], [170, 170], [150, 20]], 'rgba(200,60,50,.32)'); // 孫
    tint([[-320, -40], [-80, -60], [120, -40], [150, 20], [170, 170], [-320, 170]], 'rgba(60,140,80,.35)'); // 劉
  }
  // 長江、漢水
  ctx.strokeStyle = 'rgba(50,90,130,.75)'; ctx.lineWidth = 6; ctx.lineCap = 'round';
  ctx.beginPath(); ctx.moveTo(cx - 310, cy + 110); ctx.bezierCurveTo(cx - 150, cy + 40, cx + 40, cy + 120, cx + 310, cy + 50); ctx.stroke();
  ctx.lineWidth = 4; ctx.beginPath(); ctx.moveTo(cx - 200, cy - 40); ctx.bezierCurveTo(cx - 80, cy - 10, cx - 30, cy + 20, cx + 10, cy + 80); ctx.stroke();
  // 地名與旗
  ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.font = '900 26px "Noto Serif TC", serif';
  for (const [k, [x, y, name]] of Object.entries(PADS)) {
    const on = V.asking && !V.flags[k];
    ctx.strokeStyle = on ? `rgba(255,212,107,${0.6 + 0.3 * Math.sin(T * 4)})` : 'rgba(90,60,30,.5)'; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.ellipse(x, y, 62, 28, 0, 0, Math.PI * 2); ctx.stroke();
    ctx.fillStyle = 'rgba(60,40,20,.85)'; ctx.fillText(name, x, y);
    const f = V.flags[k];
    if (f) {
      ctx.strokeStyle = '#4a3424'; ctx.lineWidth = 4; ctx.beginPath(); ctx.moveTo(x + 40, y + 10); ctx.lineTo(x + 40, y - 70); ctx.stroke();
      ctx.fillStyle = f === '援' ? '#c0503a' : '#3e7b50'; ctx.beginPath(); ctx.moveTo(x + 40, y - 70); ctx.lineTo(x + 86, y - 58); ctx.lineTo(x + 40, y - 44); ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#fff'; ctx.font = '900 16px "Noto Serif TC", serif'; ctx.fillText(f, x + 56, y - 57); ctx.font = '900 26px "Noto Serif TC", serif';
    }
  }
  ctx.restore();
}
// 草廬：茅草屋頂、竹籬
function hut(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 10, 6, 110, 24, 90, 0.35);
  poly(ctx, [[-90, 0], [90, 0], [90, -64], [-90, -64]], '#b39a72', 2.2);
  poly(ctx, [[-18, 0], [18, 0], [18, -44], [-18, -44]], '#4a3424', 1.8);
  poly(ctx, [[-112, -60], [112, -60], [70, -130], [-70, -130]], '#a08a50', 2.4);
  ctx.strokeStyle = 'rgba(80,60,30,.5)'; ctx.lineWidth = 2; for (let x = -100; x <= 100; x += 12) { ctx.beginPath(); ctx.moveTo(x, -62); ctx.lineTo(x * 0.65, -128); ctx.stroke(); }
  ctx.strokeStyle = '#6a8a4a'; ctx.lineWidth = 3; for (let x = -150; x <= 150; x += 18) { if (Math.abs(x) < 40) continue; ctx.beginPath(); ctx.moveTo(x, 230 - 200); ctx.lineTo(x, 230 - 236); ctx.stroke(); }
  ctx.restore();
}
